import { render } from "./ChatWidget.vue?vue&type=template&id=04ec31d8&scoped=true"
import script from "./ChatWidget.vue?vue&type=script&lang=ts"
export * from "./ChatWidget.vue?vue&type=script&lang=ts"

import "./ChatWidget.vue?vue&type=style&index=0&id=04ec31d8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-04ec31d8"

export default script